import React from "react";
import bg from "assests/News/news-bg.jpg";
import { Link } from "react-router-dom";
import Container from "Components/Container/Container";

const Hero = ({ onHandleSelectedCat, selectedCat, data }) => {
  return (
    <section
      style={{ backgroundImage: `url(${bg})` }}
      className="scroll-section-special"
    >
      <Container className="pb-12">
        <div className="text-2xl text-[#808080] flex items-center gap-x-2  pt-32  lg:pt-48">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <span>|</span>
          <p className="capitalize">news and events</p>
        </div>
        <h2 className="text-white text-6xl md:text-7xl lg:text-8xl bebas uppercase mt-2 tracking-[12px]">
          what's new
        </h2>
        <div className="flex items-center content-center flex-wrap gap-6 mt-6">
          {[...new Set(data?.map(({ category }) => category))]?.map(
            (uniqueCategory, index) => (
              <button
                onClick={() => onHandleSelectedCat(uniqueCategory)}
                className={` border border-light px-8 py-2.5 ${
                  selectedCat === uniqueCategory
                    ? "bg-light text-black"
                    : "bg-[#000000a9] text-white "
                }`}
                key={index}
              >
                {uniqueCategory}
              </button>
            )
          )}
        </div>
      </Container>
    </section>
  );
};

export default Hero;
